import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: "AIzaSyB9Y-XiOb0HaDv1g2-MF713DRGWAM2kE9I",
  authDomain: "collaudoelmec.firebaseapp.com",
  projectId: "collaudoelmec",
  storageBucket: "collaudoelmec.firebasestorage.app",
  messagingSenderId: "989212354221",
  appId: "1:989212354221:web:6ee6be4e2590cc749dc824",
  measurementId: "G-M3JD3GQYQT"
};

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export const getFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'BErwk9uLOa0Xz6tZMH8QfIE4Sk0Xsh9euOYYPI1NBou3GpLIAumT2Xl5PJW9lWOzaMTYph1g0XgFndxUh5tM9JQ'  
      })
      if (token) {
        console.log('FCM Token', token)
        return token
      } else {
        throw new Error('FCM token is null')
      }
    } else {
      throw new Error('Notification permission denied')
    }
  } catch (error) {
    console.error('Error getting FCM token:', error)
    return null
  }
}

export { firebaseConfig, messaging }